<template>
  <span>Unknown component: {{type}}</span>
</template>

<script>
export default {
  props: ['type']
}
</script>
